export enum drivingMode {
  PRODUCTION = 'production',
  DEVELOPMENT = 'development',
  DRIVING = 'driving'
}

class Driving {
  private mode: boolean = false
  private play: boolean = false
  private depotStartPosition: any = {
    lat: null,
    lng: null
  }
  private lastPosition: any = {
    lat: null,
    lng: null
  }
  private routes: any = null
  private speed: number = 5

  initPlay(): any {
    this.lastPosition.lat = null
    this.lastPosition.lng = null
    this.routes = null
  }
  isDriving(): boolean {
    return this.mode
  }
  changeMode(val: boolean): boolean {
    this.mode = val
    return this.mode
  }
  isPlay(): boolean {
    return this.play
  }
  setPlay(): boolean {
    this.play = true
    return this.play
  }
  setStop(): boolean {
    this.play = false
    return this.play
  }
  setDepotStartPosition(value: any): any {
    this.depotStartPosition = { lat: value.lat, lng: value.lng }
    return this.depotStartPosition
  }
  isLastPosition(): any {
    const lat = this.lastPosition.lat || null
    const lng = this.lastPosition.lng || null
    if (lat === null || lng === null) {
      this.lastPosition = this.depotStartPosition
    }
    return this.lastPosition
  }
  setLastPosition(value: any): any {
    this.lastPosition = { lat: value.lat, lng: value.lng }
    return this.lastPosition
  }

  getRoutes(): any {
    return this.routes ? this.routes : null
  }
  setRoutes(value: any): any {
    this.routes = value
  }
  getRoutesLegs(index: number = 0): any {
    if (!this.routes) return null
    const legs = this.routes[0].legs[index]
    let distance = legs.distance.value
    let duration = legs.duration.value
    const overview_path = this.routes[0].overview_path[0]
      ? {
          lat: this.routes[0].overview_path[0].lat(),
          lng: this.routes[0].overview_path[0].lng()
        }
      : null
    if (!overview_path)
      return {
        distance: { value: 0 },
        duration: { value: 0, text: '0分' }
      }

    // eslint-disable-next-line no-labels
    outer: for (
      let steps_index = 0;
      steps_index <= legs.steps.length;
      steps_index++
    ) {
      const path = legs.steps[steps_index].path
      for (let path_index = 0; path_index < path.length; path_index++) {
        if (
          path[path_index].lat() === overview_path.lat &&
          path[path_index].lng() === overview_path.lng
        ) {
          // eslint-disable-next-line no-labels
          break outer
        }
      }
      distance = distance - legs.steps[steps_index].distance.value
      duration = duration - legs.steps[steps_index].duration.value
    }
    let duration_hour = 0
    let duration_min = Math.round(duration / 60)
    if (duration > 3600) {
      duration_hour = Math.floor(duration / 3600)
      duration_min = Math.round((duration % 3600) / 60)
    }
    let duration_text = duration_hour > 0 ? String(duration_hour) + '時間' : ''
    duration_text = duration_text + String(duration_min) + '分'
    return {
      distance: { value: distance },
      duration: { value: duration, text: duration_text }
    }
  }
  getRoutesOverViewPath(index: number = 0): any {
    const overview_path = this.routes[0].overview_path[index]
    this.routes[0].overview_path.shift()
    return this.routes ? overview_path : null
  }
  isNotExistRoutesOverViewPath(): boolean {
    return this.routes ? !(this.routes[0].overview_path.length > 0) : true
  }

  getSpeed(): number {
    return this.speed
  }
  changeSpeed(value: number) {
    this.speed = value
  }
  fastSpeed() {
    this.speed = this.speed < 10 ? this.speed + 1 : this.speed
  }
  slowSpeed() {
    this.speed = this.speed > 1 ? this.speed - 1 : this.speed
  }

  sleep = () => new Promise((resolve) => setTimeout(resolve, this.getSpeed()))
}
const driving = new Driving()

export { driving }
